import { z } from 'zod';

/**
 * One metadata entry. Values the API holds as strings are edited as text; anything else
 * (numbers, objects, lists) is edited as JSON so a round trip never changes its type.
 */
export const metadataEntrySchema = z
  .object({
    key: z
      .string()
      .trim()
      .min(1, { error: 'products:validation.metadataKeyRequired' })
      .max(120, { error: 'products:validation.metadataKeyLength' }),
    value: z.string(),
    json: z.boolean(),
  })
  .refine(
    (entry) => {
      if (!entry.json) return true;
      try {
        JSON.parse(entry.value);
        return true;
      } catch {
        return false;
      }
    },
    { path: ['value'], error: 'products:validation.metadataJson' },
  );

export type MetadataEntryForm = z.infer<typeof metadataEntrySchema>;
